import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import styles from './Forms.scss';
import textLinksStyles from '../Buttons/TextLinks/textlinks.scss';

function FormLabel(props) {
    const { children, hint, link, required, help, style, attributes } = props;

    let labelClassName = 'label-text';

    if (required) {
        labelClassName += '-required';
    }

    return (
        <div className={styles['form-label']} style={style} {...attributes}>
            <span className={styles[labelClassName]}>
                {children}
            </span>
            {hint && <span className={styles['label-hint']}>
                {hint}
            </span>}
            {link && link.text && (
                <span className={textLinksStyles['text-link']} role="presentation" {...link}>
                    {link.text}
                </span>
            )}
            {help && <span className="help-icon" title={help} />}
        </div>
    );
}

FormLabel.displayName = displayName('Forms/FormLabel');

FormLabel.propTypes = {
    children: PropTypes.node.isRequired,
    required: PropTypes.bool,
    help: PropTypes.string,
    hint: PropTypes.node,
    link: PropTypes.any,
    style: PropTypes.object,
    attributes: PropTypes.object,
};

FormLabel.defaultProps = {
    required: false,
    help: '',
    hint: null,
    link: null,
    style: {},
    attributes: {},
};

export default FormLabel;
